module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Model-Q-1065.bafb7af8.jpg";